export const currenciesFormat = {
  NGN: "en-NG",
  KES: "en-KE",
  USD: "en-US",
};
